function TableEmptyOverlay({ children, headerOffsetClassName = 'top-[42px]' }) {
  return (
    <div
      className={`pointer-events-none absolute bottom-0 left-0 right-0 ${headerOffsetClassName} hidden items-center justify-center px-6 md:flex`}
    >
      {children}
    </div>
  );
}

function TableEmptyRow({ colSpan, heightClassName = 'h-[280px]' }) {
  return (
    <tr className="border-t border-[var(--theme-border-soft)]">
      <td className={`${heightClassName} p-0`} colSpan={colSpan} />
    </tr>
  );
}

TableEmptyOverlay.Row = TableEmptyRow;

export default TableEmptyOverlay;
